const trackMutinyConversion = (conversionName) => {
  window.mutiny = window.mutiny || []
  window.mutiny?.client?.trackConversion({ name: conversionName })
}

export default trackMutinyConversion
